import React, { useMemo } from "react";
import { UserNavItemSection } from "./UserNavItemSection";
import { HomeIcon } from "shared/icons/NavIcons/HomeIcon";
import { routes } from "config";
import { CircleStackIcon } from "shared/icons/CircleStackIcon";
import { TagIcon } from "shared/icons/TagIcon";

export const UserNavItems = ({ isCollapsed }: { isCollapsed: boolean }) => {
  const mainMenuTopItems = useMemo(
    () => [
      {
        enabled: true,
        subItems: [
          {
            title: "Surveys",
            link: routes.surveys,
            icon: <HomeIcon />,
            enabled: true,
          },
          {
            title: "Supporting information",
            link: routes.supportingInfos,
            icon: <CircleStackIcon />,
            enabled: true,
          },
          {
            title: "Tags",
            link: routes.tags,
            icon: <TagIcon />,
            enabled: true,
          }
        ],
      },
    ],
    []
  );

  return (
    <div className="_d-flex-dir-col-jc-sb">
      {mainMenuTopItems.map((props, i) => (
        <UserNavItemSection key={i} isCollapsed={isCollapsed} {...props} />
      ))}
    </div>
  );
};
